import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangelogData } from '@compiere-ws/models/changelog-data';
import { ChangelogResponse } from '@compiere-ws/models/changelog-response';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChangelogsService {
  private url: string;

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
    this.url = this.config.getBackendResource('changeLog');
  }

  getChangeLogInfo(table_id: number, recordId: string): Observable<ChangelogResponse> {
    return this.http.get<ChangelogResponse>(`${this.url}/getInfo?tableId=${table_id}&recordId=${recordId}`);
  }

  getChangeLogs(table_id: number, recordId: string, offset: number, limit: number): Observable<ChangelogData[]> {
    return this.http.get<ChangelogData[]>(
      `${this.url}/data?tableId=${table_id}&recordId=${recordId}&offset=${offset}&limit=${limit}`
    );
  }
}
